import $ from "jquery";

window.bm_gtag = {

	init: function () {
		window.dataLayer = window.dataLayer || [];
		if(typeof gtag !== 'function') {
			window.gtag = function(){dataLayer.push(arguments);};
		}

        document.addEventListener("gaGtagEvent", function(e) {
            for(var i in e.detail.events) {
                bm_gtag.processEvent(e.detail.events[i]);
            }
        });

        for(var i in pageEvents) {
            bm_gtag.processEvent(pageEvents[i]);
        }

		$(function (){
			$("a").on('click', function (event) { // check link click
                let $anchor = $(this);
				let href = $(this).attr('href');
				let data = window.pageDataJson || {};
				data = Object.assign(data, {
					'href': href
				});

                const product = new RegExp("\\/produkt\\/\\w+\\/?");
                const category = new RegExp("\\/kategorie\\/\\w+\\/?");

                if(product.test(href)) {
                    window.bm_gtag.productDetailClick(data, $anchor);
                }

                if(category.test(href)) {
                    window.bm_gtag.categoryClick(data, $anchor);
                }
			});
		})
	},

    processEvent: function (event) {
        gtag("event", event.type, event.data);
    },

    productDetailClick: function (data, anchor) {
        let request = $.get('/index.php', {
            page: 'eshopAjax',
            action: 'getGTMDetailData',
            url: data.href,
        }, 'json');

        request.done(function (response) {
            if(response.success) {
                bm_gtag.processEvent({
                    type: 'select_item',
                    data: {
                        // item_list_id: 'detail', // TODO - vymyslet jak zpresnit informaci o tom, odkud proklik pochazi
                        // item_list_name: 'detail',
                        items: [response.data]
                    }
                });
            } else {
                console.log('error', response.error);
            }
        }).fail(function (jqXHR, textStatus) {
            console.log('error', jqXHR, textStatus);

        })
    },

    categoryClick: function (data, $anchor) {

        let request = $.get('/index.php', {
            page: 'eshopAjax',
            action: 'getGTMCategoryData',
            url: data.href,
        }, 'json');

        request.done(function (response) {
            if(response.success) {
                bm_gtag.processEvent({
                    type: 'select_content',
                    data: {
                        content_type: 'category',
                        content_id: response.data.cooluri,
                    }
                });
            } else {
                console.log('error', response.error);
            }
        }).fail(function (jqXHR, textStatus) {
            console.log('error', jqXHR, textStatus);

        })
    },

	updateCookieConsent: function (consentJson) {
		gtag('consent', 'update', consentJson);
	}
}

$(function (){
    bm_gtag.init();
});

